export default __webpack_public_path__ + "static/media/NeSTArch.fc370b2d.png";